/**
 * The storefront identity's length limits. Their own module, free of
 * decorators, because both sides need them: the DTO enforces them and the
 * fields that write them refuse to exceed them. Importing the DTO into a
 * client component drags class-validator into the browser instead.
 *
 * A UI that lets someone type past the DTO turns a 400 into a mystery.
 *
 * The name is 30 because it is a masthead, not a field: longer than that and it
 * wraps to a second 62px line and pushes the whole page down. Three live
 * accounts already exceed it (longest 35), all of them clients rather than
 * creators — their stored name keeps working everywhere it is read, and the
 * limit only applies the next time someone edits it.
 */
export const NAME_MAX = 30;
/** 90 since 2026-09-14: the tagline is the intro card's headline, about three
 *  lines on a phone. 65 stored bios were longer; the headline cuts them at a
 *  word, and the limit applies the next time their owner edits the line. */
export const BIO_MAX = 90;
